import classNames from 'classnames';
import { FieldProps, useFormikContext } from 'formik';
import { useCallback } from 'react';
import { IDadataArea } from 'ud-ui/components/dadata-address-autocomplete';
import { DadataAreaType } from 'ud-ui/components/dadata-address-autocomplete/domain/entities/dadata-area.entity';
import UDFormFieldWrapper from '../../wrapper';
import { UDFormComponentProps } from '../types';
import { UDDadataAreaSelect, UDDadataAreaSelectProps } from './component';

type UDFormAddressSelectProps = UDFormComponentProps &
  UDDadataAreaSelectProps & {
    allowedTypes?: DadataAreaType[];
  };

type Returning = (props: UDFormAddressSelectProps) => JSX.Element;

export const UDFormAddressSelect: Returning = (props) => {
  const { name, containerProps, required, label, labelProps, allowedTypes = [DadataAreaType.CITY], ...otherSelectProps } = props;

  const { setFieldValue } = useFormikContext();
  const onChange = useCallback(
    (value: IDadataArea | undefined) => {
      setFieldValue(name, value);

      if (props.onChange) {
        props.onChange(value);
      }
    },
    [name, props, setFieldValue],
  );

  return (
    <UDFormFieldWrapper name={name} containerProps={containerProps} label={label} labelProps={labelProps} required={required}>
      {({ field }: FieldProps<any>) => (
        <UDDadataAreaSelect
          {...field}
          className={classNames('w-full', otherSelectProps?.className)}
          onChange={onChange}
          allowedTypes={allowedTypes}
        />
      )}
    </UDFormFieldWrapper>
  );
};
